import { createSlice } from "@reduxjs/toolkit";
import { IUserSlice } from "../../../models/common/IUserProfile";

const initialUserState: IUserSlice = {
  userDetails: undefined,
  userProfileData: undefined,
  token:undefined,
  userPrivileges:undefined,
  loginDetail:undefined,
  isAuthenticated:false
};

const userSlice = createSlice({
  name: "user",
  initialState: initialUserState,
  reducers: {
    setUserDetails: (state, action: { payload: any }) => {
      state.userDetails = action.payload;
      state.isAuthenticated = action.payload?.access_token ? true : false;
    },
    setUserProfileData: (state, action: { payload: any }) => {
      state.userProfileData = action.payload;
      state.loginDetail = action.payload;
      state.isAuthenticated = action.payload ? true : false;
    },
  },
});

export const { setUserDetails,setUserProfileData } = userSlice.actions;

const userReducer = userSlice.reducer;

export type userState = ReturnType<typeof userReducer>;

export default userReducer;
